import { render } from "./OurPurpose.vue?vue&type=template&id=2f15cbf6&scoped=true"
import script from "./OurPurpose.vue?vue&type=script&lang=js"
export * from "./OurPurpose.vue?vue&type=script&lang=js"

import "./OurPurpose.vue?vue&type=style&index=0&id=2f15cbf6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f15cbf6"]])

export default __exports__